import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import MoveMEoutWrapper from "@components/layouts/moveMEoutWrapper";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function MoveMEoutHome(): ReactElement {
    return (
        <MoveMEoutWrapper>
            <TermsAndConditions
                domain="movemeout.com"
                category="Moving Services"
            />
        </MoveMEoutWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
